import React, { useCallback, useState, useRef, useEffect } from 'react';
import { Form } from '@unform/web';
import { toast } from "react-toastify";
import Select from "react-select";
import makeAnimated from 'react-select/animated';
import api from '../../services/api';

import { Container } from './styles';
const BindMission = ({ setModalState, missions }) => {
	const [modalLoading, setModalLoading] = useState(false);
	const [childs, setChilds] = useState([])
	const [totalChild, setTotalChild] = useState(0)
	const [ages, setAges] = useState([
		{ label: 9, value: 9 },
		{ label: 10, value: 10 },
		{ label: 11, value: 11 },
		{ label: 12, value: 12 }
	])
	const [nameDisabled, setNameDisabled] = useState(false)
	const [attributeDisabled, setaAttributeDisabled] = useState(false)
	const [mission, setMission] = useState()
	const [childSpecific, setChildSpecific] = useState()
	const [attributes, setAttributes] = useState({})

	const formRef = useRef(null);
	const token = localStorage.getItem("@Ocariot:token");


	const checkAttributes = () => {
		getData();
		if (Object.keys(attributes).length !== 0) {
			setNameDisabled(true)

		} else if (Object.keys(attributes).length === 0) {
			setNameDisabled(false)
		}
	}

	const getData = async () => {
		let c = !!attributes.class
		let g = !!attributes.genre
		let c2 = attributes.class
		let g2 = attributes.genre

		const qField = `
        {"qField": ["${c == true ? 'class' : ''}", "${g == true ? 'genre' : ''}"], 
        "q": ["${c == true ? c2 : ''}", "${g == true ? g2 : ''}"]
        }`

		missions.forEach(mission => {
			mission.label = `${mission.title} - ${mission.skill}`;
			mission.value = `${mission._id}`;
		})

		await api.get("child", {
			headers: {
				Authorization: `Bearer ${token}`,
			},
			params: {
				filter: `${qField}`
			}
		}).then((res) => {
			res.data.data.forEach((c) => {
				c.label = c.nickname;
				c.value = c.nickname;
			})

			let changeTotalChild;
			if (c == true || g == true)
				changeTotalChild = 1;
			else if (c == false && g == false) {
				changeTotalChild = 0;
				setTotalChild(changeTotalChild)
			}
			if (childSpecific !== undefined) {
				setTotalChild(1)
			} else if (!!changeTotalChild) {
				let total = res.data.data.length
				setTotalChild(total)
			}

			setChilds(res.data.data)
		}).catch((err) => {
			console.log(err)
		})
	}

	useEffect(() => {
		getData();
	}, [childSpecific]);

	const handleClose = async () => {
		let children = []
		if (childSpecific !== undefined) {
			children.push(childSpecific)
		} else {
			childs.forEach(child => {
				children.push(child._id)
			})
		}
		console.log('final', mission, children)
		try {
			await api.post(`/mission/give`, { mission, children },
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});
			toast.success(`Criança(s) vinculadas com sucesso!`);
			setModalState(false);
		} catch (err) {
			console.log('err', err)
			toast.error(`Erro ao vincular criança(s).`);
		}
	}

	return (
		<Container>
			<Form className="bind-mission" ref={formRef} onSubmit={handleClose}>
				<div>
					<label>Missão</label>
					<Select
						name="mission.name"
						placeholder="Selecione uma missão"
						options={missions} //!ver depois
						// isClearable
						onChange={(e) => {
							setMission(e.value)
							checkAttributes()
						}}
					/>

				</div>
				<div className="filter-body">
					
					<div className="left-side">
						<h3>Atrelar por atributo</h3>
						<div className="input-div">
							<label>Classe</label>
							<Select
								isDisabled={attributeDisabled}
								name="child.class"
								placeholder="Selecione uma classe"
								isClearable
								options={[{ label: '2º', value: '2º' },
								{ label: '3º', value: '3º' },
								{ label: '4º', value: '4º' },
								{ label: '5º', value: '5º' },
								{ label: '6º', value: '6º' }]}
								onChange={(e) => {
									let values = attributes;
									values.class = e?.value;
									if (values.class == undefined) { delete values['class'] }
									setAttributes(values)
									checkAttributes()
								}}
							/>
						</div>
						<div className="input-div">
							<label>Gênero</label>
							<Select
								isDisabled={attributeDisabled}
								name="child.genre"
								placeholder="Selecione um gênero"
								isClearable
								options={[
									{ label: 'Feminino', value: 'Feminino' },
									{ label: 'Masculino', value: 'Masculino' }
								]}
								// isMulti
								onChange={(e) => {
									let values = attributes;
									values.genre = e?.value;
									if (values.genre == undefined) { delete values['genre'] }
									setAttributes(values)
									checkAttributes()
								}}
							/>
						</div>
					</div>
					<div className="right-side">
						<h3>Atrelar por ID</h3>
						<div className="input-div">
							<label>ID OCARIoT</label>
							<Select
								isDisabled={nameDisabled}
								name="child.name"
								placeholder="Selecione uma criança"
								options={childs}
								isClearable
								onChange={(e) => {
									let a = childSpecific;
									a = e?._id;
									setChildSpecific(a)
									if (a !== undefined) {
										setaAttributeDisabled(true)
									} else if (a == undefined) {
										setaAttributeDisabled(false)
										setChildSpecific(undefined)
									}
									checkAttributes()
								}}
								// isMulti
							/>
						</div>
					</div>
				</div>
				

				<div className="button-footer">
					<h3>Total de crianças selecionadas: {totalChild}</h3>
					<button className="submit-button" type="submit">Adicionar</button>
				</div>			
			</Form>
		</Container>
	);
}

export default BindMission;